<template>
  <div v-if="show">
    <div class="box" v-if="showContent">
      <div class="box">
        <ContentLoading
          :show="showContent"
          :grid="grid"
          :width="300"
          :height="80"
          :mobile-grid="mobileGrid"
          :mobile-width="30"
          :mobile-height="20"
        />
      </div>
      <ContentLoading
        :show="showContent"
        :grid="gridCard"
        :width="300"
        :height="100"
        :mobile-grid="mobileGridCard"
        :mobile-width="30"
        :mobile-height="40"
      />
    </div>
    <Form v-else title="Nova segmentação" @submit="submit" />
  </div>
</template>

<script>
import Form from './components/Form'
import { createSegment } from '@/services/segments'
import { mapGetters } from 'vuex'
import config from '@/config'
import ContentLoading from '@/components/helpers/ContentLoading'

export default {
  name: 'SegmentsCreate',
  components: {
    Form,
    ContentLoading
  },
  created () {
    if (this.getToken === config.tokenFrame) {
      this.show = true
    }
  },
  data: () => ({
    show: true,
    showContent: false,
    grid: [
      { x: 135, y: 25, rx: 0, ry: 0, innerWidth: 35, innerHeight: 3 },
      { x: 140, y: 30, rx: 0, ry: 0, innerWidth: 25, innerHeight: 3 },
      { x: 132, y: 40, rx: 1, ry: 1, innerWidth: 40, innerHeight: 10 },
    ],
    mobileGrid: [
      { x: 10, y: 0, rx: 1, ry: 1, innerWidth: 20, innerHeight: 3 },
      { x: 15, y: 5, rx: 1, ry: 1, innerWidth: 15, innerHeight: 3 },
      { x: 0, y: 10, rx: 1, ry: 1, innerWidth: 30, innerHeight: 7 }
    ],
    gridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 60, innerHeight: 100 }
    ],
    mobileGridCard: [
      { x: 5, y: 0, rx: 2, ry: 2, innerWidth: 20, innerHeight: 30 }
    ]
  }),
  computed: {
    ...mapGetters(['getToken'])
  },
  methods: {
    async submit(payload) {
      this.showContent = true
      try {
        await createSegment(payload)
        this.$swalModal(
          'Sucesso',
          'Segmentação criada com sucesso!',
          'success'
        )
        this.$router.push('/')
      } catch (error) {
        this.$swalModal(
          'Erro',
          'Não foi possível criar essa segmentação!',
          'error'
        )
      } finally {
        this.showContent = false
      }
    }
  }
}
</script>

<style>
</style>
